import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NAV_LINKS, BUSINESS } from "@/data/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-gold/20 shadow-sm py-2" : "bg-navy/30 backdrop-blur-md py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <Logo variant={scrolled ? "dark" : "light"} />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative text-sm font-semibold tracking-wide transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:bg-gold after:transition-all ${
                  isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
                } ${scrolled ? "text-navy hover:text-gold" : "text-white hover:text-gold"} ${
                  isActive ? (scrolled ? "text-gold" : "text-gold") : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={BUSINESS.phoneHref} className={`flex items-center gap-2 text-sm font-semibold ${scrolled ? "text-navy" : "text-white"}`}>
            <Phone size={15} className="text-gold" /> {BUSINESS.phone}
          </a>
          <Link
            to="/contact"
            data-testid="header-quote-btn"
            className="bg-gold text-navy px-6 py-2.5 text-sm font-bold tracking-wide hover:bg-gold-light transition-colors"
          >
            Get a Quote
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden ${scrolled ? "text-navy" : "text-white"}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-navy border-t border-gold/20 px-5 py-6 space-y-4">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => `block text-base font-semibold ${isActive ? "text-gold" : "text-white"}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="block bg-gold text-navy text-center px-6 py-3 font-bold">
            Get a Quote
          </Link>
        </div>
      )}
    </header>
  );
};
